import template from './sw-cms-preview-acris-blog-subtitle.html.twig';
import './sw-cms-preview-acris-blog-subtitle.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-subtitle', {
    template
});
